import { render, staticRenderFns } from "./SowingMethods.vue?vue&type=template&id=de6d07d0"
import script from "./SowingMethods.vue?vue&type=script&lang=js"
export * from "./SowingMethods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports